<template>
  <VueMultiselect
    v-bind="vBind"
    v-on="vOn"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>
  </VueMultiselect>
</template>

<script>
  import VueMultiselect from 'vue-multiselect';

  // Wrapper for Vue-Multiselect

  export default {
    components: {
      VueMultiselect,
    },
    props: {
      value: {
        type: [Object, Array, String, Number],
        default: null,
      },
      options: {
        type: Array,
        required: true,
      },
      placeholder: {
        type: String,
        default: '',
      },
      showNoResults: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
        default: 'label',
      },
      trackBy: {
        type: String,
        default: 'value',
      },
      hideDropdown: {
        type: Boolean,
        default: false,
      },
      hideCaret: {
        type: Boolean,
        default: false,
      },
      simpleValue: {
        type: Boolean,
        default: false,
      },
      error: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      vBind() {
        return {
          ...this.$attrs,
          value: this.localValue,
          options: this.options,
          placeholder: this.placeholder,
          showNoResults: this.showNoResults,
          label: this.label,
          trackBy: this.trackBy,
          class: {
            'multiselect--no-dropdown': this.hideDropdown,
            "multiselect--no-caret": this.hideCaret,
            "multiselect--error": this.error,
          },
        };
      },
      vOn() {
        return {
          ...this.$listeners,
          input: (value) => this.localValue = value,
        };
      },
      // This acts as a wrapper for the value that and converts it depending on simpleValue prop:
      // False -> Value is the whole option object, default Vue-Multiselect behavior.
      // True  -> Value is just the option property defined by trackBy.
      localValue: {
        get() {
          return this.simpleValue
            ? this.options.find((option) => option[this.trackBy] === this.value)
            : this.value;
        },
        set(newValue) {
          const emitValue = this.simpleValue
            ? (newValue !== null ? newValue[this.trackBy] : null)
            : newValue;
          this.$emit('input', emitValue)
        }
      }
    },
  };
</script>
